const cssUrl = `${import.meta.env.VITE_CDN_ROOT}${import.meta.env.VITE_ASCEND_AWESOME_VERSION}/css/trustage-aa--wc.css`

const t = document.createElement('template')
t.innerHTML = `
<link href="${cssUrl}" rel="stylesheet" />
<style>
::slotted([slot="control-error"]) {
  color: red;
  margin: 0;
}
.error-text {
  color: red;
}
</style>
`
const TemplateFormControlMessagingStyles = t
export { TemplateFormControlMessagingStyles }
